var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-layout"},[_c('div',{staticClass:"nav hidden-lg-up"},[_c('router-link',{staticClass:"basix-home",attrs:{"to":{path: '/'}}})],1),_vm._v(" "),_c('div',{staticClass:"main row"},[_c('div',{staticClass:"auth-wallpaper auth-content col-md-12"},[_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74eaee2e","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/AuthLayout.vue
// module id = 1553
// module chunks = 27